const finiteNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

export const normalizeTradeQuantity = (value, fallback = null) => {
  const quantity = finiteNumber(value);
  if (quantity == null || quantity <= 0 || quantity > 1_000_000_000) return fallback;
  return Number(quantity.toFixed(6));
};

export const calculateTradeMetrics = ({
  direction,
  fillPrice,
  markPrice,
  quantity = 1,
  pointValue = null,
  currency = null,
}) => {
  const fill = finiteNumber(fillPrice);
  const mark = finiteNumber(markPrice);
  const normalizedQuantity = normalizeTradeQuantity(quantity, 1);
  const normalizedPointValue = finiteNumber(pointValue);
  if (fill == null || fill <= 0 || mark == null || mark <= 0) return null;

  const pointChange = String(direction || "").toLowerCase() === "short"
    ? fill - mark
    : mark - fill;
  const validPointValue =
    normalizedPointValue != null && normalizedPointValue > 0
      ? normalizedPointValue
      : null;
  const normalizedCurrency = String(currency || "").trim().toUpperCase();

  return {
    pointChange,
    percentChange: (pointChange / fill) * 100,
    quantity: normalizedQuantity,
    pointValue: validPointValue,
    currency: /^[A-Z]{3}$/.test(normalizedCurrency) ? normalizedCurrency : null,
    monetaryChange:
      validPointValue == null
        ? null
        : pointChange * normalizedQuantity * validPointValue,
  };
};

export const formatSignedTradeCurrency = (value, currency) => {
  const amount = finiteNumber(value);
  const code = String(currency || "").trim().toUpperCase();
  if (amount == null || !/^[A-Z]{3}$/.test(code)) return null;

  let formatted;
  try {
    formatted = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: code,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Math.abs(amount));
  } catch (_error) {
    return null;
  }
  if (amount > 0) return `+${formatted}`;
  if (amount < 0) return `-${formatted}`;
  return formatted;
};

export const formatTradeQuantity = (value) => {
  const quantity = normalizeTradeQuantity(value, 1);
  return quantity.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 6,
  });
};
